import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
    selector: "circulation-dialog",
    templateUrl: "./dialog.component.html",
    styleUrls: ["./dialog.component.scss"],
    standalone: false
})
export class DialogComponent {
  //Variable ref to enum
  dialogResult = DialogResult;

  @Input() title: string;
  @Input() opened: boolean;
  @Input() yesButtonText = "common.yes";
  @Input() noButtonText = "common.no";
  @Input() content = "Content";
  @Input() showNoButton = true;
  @Input() showYesButton = true;

  @Output() openedChange = new EventEmitter<boolean>();
  @Output() dialogClosed = new EventEmitter<DialogResult>();

  onClose(result: DialogResult): void {
    this.opened = false;
    this.openedChange.emit(this.opened);
    this.dialogClosed.emit(result);
  }
}

export enum DialogResult {
  Yes,
  No,
  Cancel
}
